import React from "react";
import { OCC_STATUS_PILL } from "./taskHubUtils";

// The ticket-style status pill (same markup as MaintenanceBadges.Pill) over
// the task lifecycle vocabulary.
// paused: someone stopped their clock on a tracked task. It only overrides
// the in-flight states; finished or submitted work keeps its own pill.
export default function StatusPill({ status, paused }) {
  const showPaused = paused && status !== "completed" && status !== "waiting_validation";
  const c = showPaused ? OCC_STATUS_PILL.paused : OCC_STATUS_PILL[status] || OCC_STATUS_PILL.new;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full pl-2 pr-2.5 py-0.5 ${c.bg} border ${c.border} whitespace-nowrap`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />
      <span className={`text-[11px] font-semibold leading-4 ${c.text}`}>
        {c.label}
      </span>
    </span>
  );
}
